module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-300.ca7cb6c5.woff";